var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        { staticClass: "card-bg-2", attrs: { id: `step-${_vm.index}` } },
        [
          _c(
            "div",
            {
              staticClass: "headline pb-0",
              class: { "grey--text": _vm.disabled },
              staticStyle: { "align-items": "baseline", display: "flex" },
            },
            [
              _vm._v("\n      Time Series\n      "),
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "open-on-hover": "",
                    "open-delay": 400,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              {
                                staticClass: "clickable ml-2",
                                attrs: { color: "primary" },
                                on: {
                                  click: function ($event) {
                                    _vm.showHelp = true
                                  },
                                },
                              },
                              on
                            ),
                            [_vm._v("\n            info_outline\n          ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.showHelp,
                    callback: function ($$v) {
                      _vm.showHelp = $$v
                    },
                    expression: "showHelp",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _vm._v(
                          " The time series shown are the time series from all selected stations within the selected date range.\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          staticClass:
            "card-bg-2 pa-0 default-border-bottom scroll-border-bottom",
        },
        [
          _c(
            "v-layout",
            { staticClass: "default-border-bottom scroll-border-bottom" },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-item-group",
                    {
                      attrs: { mandatory: "", "active-class": "white--text" },
                      model: {
                        value: _vm.filterToggle,
                        callback: function ($$v) {
                          _vm.filterToggle = $$v
                        },
                        expression: "filterToggle",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticStyle: { display: "inline", cursor: "default" },
                        },
                        [_vm._v("Show:")]
                      ),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [_vm._v("Available")]
                              )
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "pr-2",
                                      class: {
                                        "info--text font-weight-bold":
                                          _vm.selectedTimeSeries.length > 0,
                                      },
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.selectedTimeSeries.length)
                                      ),
                                    ]
                                  ),
                                  _vm._v("\n            Selected\n          "),
                                ]
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-flex", { staticClass: "pr-2" }),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            ref: "timeSeriesTable",
            staticClass: "analytes-table",
            class: {
              "five-items": _vm.pagination.rowsPerPage === 5,
              "ten-items": _vm.pagination.rowsPerPage === 10,
              "twenty-five-items": _vm.pagination.rowsPerPage === 25,
            },
            attrs: {
              search: _vm.search,
              "select-all": "",
              disabled: _vm.disabled,
              headers: _vm.headers,
              items: _vm.allTimeSeries,
              pagination: _vm.pagination,
              "item-key": _vm.selectionKey,
              "custom-filter": _vm.customFilter,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "no-data",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "pa-4 text-xs-center" },
                      [
                        _c("v-icon", { attrs: { color: "warning" } }, [
                          _vm._v("warning"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n        No matching time series found\n      "
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "no-results",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "pa-4 text-xs-center" },
                      [
                        _c("v-icon", { attrs: { color: "warning" } }, [
                          _vm._v("warning"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v("\n        No matching series found\n      "),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "headers",
                fn: function (props) {
                  return [
                    _c(
                      "tr",
                      [
                        _c(
                          "th",
                          [
                            _c("v-checkbox", {
                              staticClass: "analyteTable",
                              attrs: {
                                disabled:
                                  _vm.filterToggle ==
                                    _vm.filterToggles.unavailable ||
                                  _vm.disabled,
                                color: "primary",
                                headers: _vm.headers,
                                "item-key": _vm.selectionKey,
                                "input-value": props.all,
                                indeterminate: props.indeterminate,
                                primary: "",
                                "hide-details": "",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleAll()
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(props.headers, function (header) {
                          return _c(
                            "th",
                            {
                              key: header.text,
                              class: [
                                "column",
                                header.sortable && "sortable",
                                _vm.pagination.descending ? "desc" : "asc",
                                header.value === _vm.pagination.sortBy
                                  ? "active"
                                  : "",
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort(
                                    header.sortable,
                                    header.value
                                  )
                                },
                              },
                            },
                            [
                              header.sortable
                                ? _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("arrow_upward"),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n          " +
                                  _vm._s(header.text) +
                                  "\n        "
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          clickable:
                            (!_vm.isUnavailable(props.item) ||
                              props.selected) &&
                            !_vm.disabled,
                        },
                        attrs: { active: props.selected },
                        on: {
                          click: function ($event) {
                            return _vm.toggleRow(props)
                          },
                        },
                      },
                      [
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              staticClass: "clickable",
                              attrs: {
                                color: "primary",
                                disabled: _vm.isUnavailable(props.item),
                                "input-value": props.selected,
                                primary: "",
                                "hide-details": "",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.LocationName) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(props.item.DisplayName) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatDisplayDate(
                                  props.item.FirstRecordDate
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatDisplayDate(props.item.LastRecordDate)
                              ) +
                              "\n        "
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.selectedTimeSeries,
              callback: function ($$v) {
                _vm.selectedTimeSeries = $$v
              },
              expression: "selectedTimeSeries",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }